import BigNumber from 'bignumber.js'
import crypto from 'crypto'

const RTP = new BigNumber(99) // percent
const payoutDecimalPlace = 2 // Adjust as needed
const maxMultiplier = new BigNumber(2).pow(24) // Adjust as needed
const hexNumberGet = 4 // Adjust as needed

export function generateLimboFairResult(serverSeed: string, clientSeed: string, nonce: number): BigNumber {
  const hash = generateHash(serverSeed, clientSeed, nonce)

  const prob = calProbFromHash(hash)
  let payoutMultiplier = calculateHouseEdge(prob).dividedBy(100)

  if (payoutMultiplier.isLessThan(1)) payoutMultiplier = new BigNumber(1)
  if (payoutMultiplier.isGreaterThan(1e6)) payoutMultiplier = new BigNumber(1e6)

  return payoutMultiplier.decimalPlaces(payoutDecimalPlace, BigNumber.ROUND_DOWN)
}

function generateHash(serverSeed: string, clientSeed: string, nonce: number): string {
  const hmac = crypto.createHmac('sha256', serverSeed)
  hmac.update(`${clientSeed}:${nonce}`)
  return hmac.digest('hex')
}

function calculateHouseEdge(prob: BigNumber): BigNumber {
  const numerator = RTP.multipliedBy(maxMultiplier)
  const denominator = maxMultiplier.multipliedBy(prob).plus(1)
  return numerator.dividedBy(denominator)
}

function calProbFromHash(hash: string): BigNumber {
  let prob = new BigNumber(0)
  for (let i = 0; i < hexNumberGet; i++) {
    const hexSubstring = hash.substring(i * 2, (i + 1) * 2)
    const decVal = new BigNumber(parseInt(hexSubstring, 16))
    prob = prob.plus(decVal.dividedBy(new BigNumber(256).pow(i + 1)))
  }
  return prob
}
